import React from 'react';
import { Section } from './ui/Section';
import { BookOpen, Target, PenTool, MessageSquare, DollarSign, Calendar, Gift } from 'lucide-react';
const chapters = [{
  icon: <BookOpen className="w-6 h-6 text-rose-500" data-id="element-9" />,
  title: 'El Micro-Negocio de PDFs',
  desc: 'Una explicación clara de cómo funciona este modelo simple.'
}, {
  icon: <Target className="w-6 h-6 text-rose-500" data-id="element-10" />,
  title: 'Descubre tu Tema Ganador',
  desc: 'Ejercicios para encontrar esa idea que ya tienes dentro.'
}, {
  icon: <PenTool className="w-6 h-6 text-rose-500" data-id="element-11" />,
  title: 'Diseño desde el Celular',
  desc: 'El paso a paso para escribir y diseñar tu PDF sin ser diseñadora.'
}, {
  icon: <MessageSquare className="w-6 h-6 text-emerald-500" data-id="element-12" />,
  title: 'Sistema CELU-VENTAS',
  desc: 'Aprende a ofrecer y vender tu PDF por WhatsApp y redes.'
}, {
  icon: <DollarSign className="w-6 h-6 text-emerald-500" data-id="element-13" />,
  title: 'Cobrar desde USA',
  desc: 'Guías simples para cobrar al mercado latino sin dolores de cabeza.'
}, {
  icon: <Calendar className="w-6 h-6 text-rose-500" data-id="element-14" />,
  title: 'Plan de Acción de 7 Días',
  desc: 'Tu ruta exacta para pasar de idea a primer lanzamiento.'
}, {
  icon: <Gift className="w-6 h-6 text-purple-500" data-id="element-15" />,
  title: 'Bonos Exclusivos',
  desc: 'Ideas de PDFs, guiones de venta y checklist de lanzamiento.'
}];
export function Contents() {
  return <Section className="bg-white" data-id="element-16">
      <div className="text-center mb-12" data-id="element-17">
        <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-18">
          ¿Qué encontrarás dentro?
        </h2>
        <p className="text-gray-600" data-id="element-19">
          Todo lo que necesitas, explicado sin palabras raras.
        </p>
      </div>

      <div className="grid gap-6 md:grid-cols-2" data-id="element-20">
        {chapters.map((chapter, index) => <div key={index} className="flex items-start p-6 rounded-xl bg-gray-50 hover:bg-rose-50 transition-colors duration-300 border border-gray-100" data-id="element-21">
            <div className="bg-white p-3 rounded-lg shadow-sm mr-4 flex-shrink-0" data-id="element-22">
              {chapter.icon}
            </div>
            <div data-id="element-23">
              <h3 className="font-bold text-gray-900 mb-1" data-id="element-24">{chapter.title}</h3>
              <p className="text-sm text-gray-600" data-id="element-25">{chapter.desc}</p>
            </div>
          </div>)}
      </div>
    </Section>;
}